export default {
    MILIGRAMAS: 1,
    GRAMAS: 2,
    QUILOGRAMAS: 3,
    CENTIMETROS: 4,
    METROS: 5,
    MILIMETROS_DE_MERCURIO: 6,
    CENTIMETROS_DE_MERCURIO: 7,
    CELSIUS: 8,
    BATIMENTOS_POR_MINUTO: 9,
    MOVIMENTOS_POR_MINUTO: 10,
    PORCENTAGEM: 11,
    NIVEL_DE_DOR: 12,
    MILIGRAMAS_POR_DECILITRO: 13,
    FRASCO: 14,
    FRASCO_AMPOLA: 15,
}